import './FacetGroupContent.scss';
import React from 'react';
import {FacetValue, HibuFacetErrorCode, HibuFilter} from '../../../facet.types';
import {FacetGroupMultiSelect} from './FacetGroupMultiSelect';
import {FacetGroupHistogram} from './FacetGroupHistogram';
import {useSelectedFiltersForGroup} from '../../../duck/filter.hooks';

type InputProps = {
    sortedValues: FacetValue[];
    fieldName: string;
    errorCode: HibuFacetErrorCode | undefined;
    isExpanded: boolean;
};

const FacetGroupContent = React.memo(({sortedValues, fieldName, errorCode, isExpanded}: InputProps) => {
    const isHistogram = fieldName.endsWith('_date');
    const selectedFilters: HibuFilter[] = useSelectedFiltersForGroup(fieldName);

    return (
        <div className="facet-values">
            <FacetGroupHistogram isHistogram={isHistogram} isExpanded={isExpanded} values={sortedValues}
                                 fieldName={fieldName} selectedFilters={selectedFilters}/>
            <FacetGroupMultiSelect isHistogram={isHistogram} isExpanded={isExpanded} sortedValues={sortedValues}
                                   fieldName={fieldName} errorCode={errorCode} selectedFilters={selectedFilters}/>
        </div>
    );
});
export default FacetGroupContent;
